import 'reflect-metadata'

import { AgropilotRole } from '../enums/agropilot-role.enum'
import { Length } from '../enums/length.enum'
import { Profil } from '../enums/profils.enum'
import { UserPermissions } from '../enums/user-permissions.enum'
import { ReportingDAO } from './reporting'
import { SaveUserPreference } from './save-user-preference'

export class UserDto {
  id?: number
  email: string
  firstname: string
  lastname: string
  regionName: string
  regionId: number | null
  campaignId: number | null
  language: string
  languageId?: number
  defaultYieldUnit: string
  defaultAreaUnit: string
  defaultApplicationUnit: string
  geolocationRadius: number
  geolocationRadiusUnit: Length
  farmId?: number
  supplierId?: number
  phoneNumber?: string
  phytoCertification?: string
  limitDisplay?: boolean
  isActive?: boolean
  isVirtual?: boolean
  createdBy?: number
  createdAt?: string
  updatedBy?: number
  updatedAt?: string
  availableRegions: string[]
  availableRegionsIds?: (number | null)[]
  permissions: UserPermissions[]
  profil?: Profil
  reportToUserId?: number
  agropilotRole?: AgropilotRole | null
  displayCloseCrops?: boolean
  lastConnectionDate?: string
  agropilotManagedReceptionSiteId?: number
  agropilotManagedHarvesterId?: number

  constructor(user?: UserDto) {
    if (user?.id) {
      this.id = user.id
    }
    this.email = user?.email ?? ''
    this.firstname = user?.firstname ?? ''
    this.lastname = user?.lastname ?? ''
    this.regionName = user?.regionName ?? ''
    this.regionId = user?.regionId ?? null
    this.campaignId = user?.campaignId ?? null
    this.language = user?.language ?? ''
    this.defaultYieldUnit = user?.defaultYieldUnit ?? ''
    this.defaultAreaUnit = user?.defaultAreaUnit ?? ''
    this.defaultApplicationUnit = user?.defaultApplicationUnit ?? ''
    this.geolocationRadius = user?.geolocationRadius ?? 0
    this.geolocationRadiusUnit = user?.geolocationRadiusUnit ?? Length.KM
    this.availableRegions = user?.availableRegions || [this.regionName]
    this.availableRegionsIds = user?.availableRegionsIds || [this.regionId]
    this.permissions = user?.permissions || []
    this.farmId = user?.farmId
    this.supplierId = user?.supplierId
    this.phoneNumber = user?.phoneNumber
    this.phytoCertification = user?.phytoCertification
    this.limitDisplay = user?.limitDisplay
    this.isActive = user?.isActive
    this.profil = user?.profil
    this.agropilotRole = user?.agropilotRole ?? null
    this.isVirtual = user?.isVirtual ?? false
    this.reportToUserId = user?.reportToUserId
    if (user?.languageId) {
      this.languageId = user.languageId
    }
    this.displayCloseCrops = user?.displayCloseCrops
    this.lastConnectionDate = user?.lastConnectionDate
    this.agropilotManagedReceptionSiteId = user?.agropilotManagedReceptionSiteId
    this.agropilotManagedHarvesterId = user?.agropilotManagedHarvesterId
  }
}

export class User {
  id?: number | null
  name?: string
  firstname: string
  lastname: string
  email: string
  regionName: string
  language: string
  permissions?: string[]
  availableRegions: string[]
  agropilotRole: AgropilotRole | null

  constructor(user?: User) {
    this.id = user?.id ?? null
    this.lastname = user && user.lastname ? user.lastname : ''
    this.firstname = user && user.firstname ? user.firstname : ''
    this.email = user && user.email ? user.email : ''
    this.regionName = user && user.regionName ? user.regionName : ''
    this.language = user && user.language ? user.language : ''
    this.permissions = user && user.permissions ? user.permissions : []
    this.availableRegions = user && user.availableRegions ? user.availableRegions : []
    this.agropilotRole = user && user.agropilotRole ? user.agropilotRole : null
  }
}

export class SaveUserPreferenceDAO extends ReportingDAO {
  languageId: number
  geolocationRadius: number
  geolocationRadiusUnit: string
  regionId: number
  limitDisplay: boolean
  defaultYieldUnitConstantId: number
  defaultAreaUnitConstantId: number
  defaultApplicationUnitConstantId: number
  campaignId: number | undefined
  displayCloseCrops: boolean
  constructor(
    saveUserPreference: SaveUserPreference,
    regionId: number,
    defaultYieldUnitConstantId: number,
    defaultAreaUnitConstantId: number,
    defaultApplicationUnitConstantId: number,
  ) {
    super(saveUserPreference)
    this.languageId = saveUserPreference.languageId
    this.geolocationRadius = saveUserPreference.geolocationRadius
    this.geolocationRadiusUnit = saveUserPreference.geolocationRadiusUnit
    this.regionId = regionId
    this.limitDisplay = saveUserPreference.limitDisplay
    this.defaultYieldUnitConstantId = defaultYieldUnitConstantId
    this.defaultAreaUnitConstantId = defaultAreaUnitConstantId
    this.defaultApplicationUnitConstantId = defaultApplicationUnitConstantId
    this.campaignId = saveUserPreference.campaignId
    this.displayCloseCrops = saveUserPreference.displayCloseCrops
  }
}
